module.exports = __webpack_public_path__ + "static/media/add-blue.3cc6697d.svg";